<style scoped>
.dlt-icon {
	border: 1px solid #e3e3e3;
	border-radius: 50%;
	color: #bbb;
	float: right;
	font-size: 12px;
	line-height: 24px;
	min-height: 26px;
	text-align: center;
	width: 26px;
	padding: 0;
    background-color: #fff;
}
.dlt-icon:hover {
	background-color: #ea1919;
	color: #fff;
}
</style>
<template>
    <div>
        <!-- <div class="clearfix rounded mt-4 pb-5 mx-auto"> -->
            <div class="row no-gutters py-3">
                <div class="col-sm-6 px-4 company-form-box-title">Cost Center Information</div> <!-- Mustafijur: 13-05-2026 -->
            </div>

            <!-- Sohel: New mappings update -->
            <b-overlay :show="showoverlay_list" rounded="sm">
                <div v-if="cost_center_list.length != 0" >
                    <div class="bank-info-inner" v-for="c_c_list in cost_center_list" :key="c_c_list.cost_center_id">
                        <ul class="bank-info">
                            <li class="m-0 px-4"> <!-- Mustafijur: 13-05-2026 -->
                                <div class="title col-6 pl-0">Name</div>
                                <div class="text col-6">{{c_c_list.cost_center_name}}</div>
                            </li>
                            <li class="m-0 px-4"> <!-- Mustafijur: 13-05-2026 -->
                                <div class="title  col-6 pl-0">Code</div>
                                <div class="text col-6">{{c_c_list.code}}</div>
                            </li>
                            <li class="m-0 px-4"> <!-- Mustafijur: 13-05-2026 -->
                                <div class="title col-6 pl-0">Cost Center Percentage</div>
                                <div class="text col-6">{{c_c_list.cost_center_percentage}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <!-- alpha fix- maked px-3 to px-4  -->
                    <div class="bank-info-inner px-4 pt-3">
                        <p>No cost center information available.</p>
                    </div>
                </div>
            </b-overlay>
            <!-- Sohel: New mappings update -->
        <!-- </div> -->
        <!-- modal starts -->
        <div class="col-sm-12  px-0">
            <b-modal id="bv-modal-add-cost-center" size="lg" hide-footer title="Cost Center Details">
                <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmitCostCenter">
                        <b-form-group  id="cost-center-group" label="CostCenter" class="" label-for="cost_center">
                            <b-form-select id="cost_center" name="cost_center" v-model="cost_center" v-validate="{ required: true }" :state="validateState('cost_center')" aria-describedby="cost_center-feedback" data-vv-as="cost_center">
                                <option value="">Select Cost Center</option>

                                <template v-if="cost_centers.length > 0">
                                    <option v-for="c_center in cost_centers" :value="c_center.id" :key="c_center.id">{{ c_center.name }}</option>
                                </template>
                            </b-form-select>
                            <b-form-invalid-feedback id="cost_center-feedback">{{ veeErrors.first('cost_center') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <div class="full-width">
                            <b-button type="submit" variant="success">Submit</b-button>
                        </div>
                        </b-form>
                </b-overlay>
            </b-modal>
        </div>
        <!-- modal ends -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            cost_centers: [],  //
            successmsg:'',
            errormsg:[],
            cost_center_list : [],   //
            showoverlay_list : false,
            showoverlay: false,
            cost_center: '', //
            cost_center_data: '',
            cost_cent: '',
            cost_id:'', //
            cost_employee_id: '', //
        }
    },
    methods:{
        getCostCenterForEmployee: function()
        {
            let currentObj = this;
            axios.get(this.$api_url+'/get-cost-center-for-employee' ,  {
                params: {}
            }).then(function(response)
            {
                this.cost_center_list = response.data;
                console.log(this.cost_center_list);
            }.bind(this)).catch(function (error)
            {
                currentObj.serverError(error);
            });
        },
        getCostCenters: function()
        {
            let currentObj = this;
            axios.get(this.$api_url+'/get-all-cost-center' ,  {
                params: {}
            }).then(function(response)
            {
                this.cost_centers = response.data;
                console.log(this.cost_centers);

            }.bind(this)).catch(function (error)
            {
                currentObj.serverError(error);
            });
        },
        addCostCenter: function()
        {
            let currentObj = this;
            axios.get(this.$api_url+'/get-all-cost-center' ,  {
                params: {}
            }).then(function(response)
            {
                this.cost_centers = response.data;
                console.log(this.cost_centers);

            }.bind(this)).catch(function (error)
            {
                currentObj.serverError(error);
            });
            this.$bvModal.show('bv-modal-add-cost-center');
            this.showoverlay = false;
        },
        onSubmitCostCenter:function()
        {
            let currentObj = this;
            let cost_center_id = this.cost_center;
            // console.log(cost_center_id);
            axios.get(this.$api_url+'/add-cost-center-employee' ,  {
                params: {
                    'cost_center_id' : cost_center_id,
                }
            }).then(function(response)
            {
                // console.log(response.data.cost_centers);
                if(response.data.success == 0)
                {
                    this.$bvToast.toast("Cost Center not inserted", {
                        title: `Failed`,
                        variant: 'danger',
                        solid: true
                    });
                }
                else
                {
                    this.$bvToast.toast("Cost Center inserted", {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                    });
                    this.cost_center_list = response.data.cost_centers;
                    this.cost_id =  cost_center_id;
                    this.cost_employee_id    = response.data.cost_employee_id;
                }
                this.$bvModal.hide('bv-modal-add-cost-center');
            }.bind(this)).catch(function (error)
            {
                currentObj.serverError(error);
            });

        },
        editCostCenter: function()
        {
            let currentObj = this;
            // let cost_center_id = '9';
            let cost_center_id = this.cost_id;
            this.cost_center =  cost_center_id;
            console.log(cost_center_id);
            axios.get(this.$api_url+'/get-all-cost-center' ,  {
                params: {}
            }).then(function(response)
            {
                // console.log(response.data);
                this.cost_centers = response.data;
                // this.cost_center =  cost_center_id;
            }.bind(this)).catch(function (error)
            {
                currentObj.serverError(error);
            });
            this.$bvModal.show('bv-modal-add-cost-center');
        },
        deleteCostCenter: function()
        {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this cost center.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
            })
            .then(value => {
                if(value)
                {
                    let currentObj = this;
                    let cost_employee_id = this.cost_employee_id;
                    let formData = new FormData();
                    formData.append('id', cost_employee_id);

                    axios.post(this.$api_url+'/employee-cost-center-delete', formData).then(function(response){
                        console.log(response.data);
                        if(response.data == '1')
                        {
                            this.$bvToast.toast('Deleted!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                            this.cost_center_list = '';
                            this.cost_id = '';
                            this.cost_employee_id = '';
                            this.cost_center = '';
                        }
                        else{
                            this.$bvToast.toast('Not Deleted!', {
                                        title: `Failed`,
                                        variant: 'danger',
                                        solid: true
                                    });
                        }
                    }.bind(this));
                }
            })
            .catch(function (error) //server error
            {
                currentObj.serverError(error);

            });
        }
    },
    created: function()
    {
        this.getCostCenterForEmployee();
        this.getCostCenters();
    },
}
</script>
